<!-- Montado en el root (no en el Shell) para que la caída del backend se vea también en el login. -->
<app-backend-down-banner />
<!-- Montado en el root (RF09): visible en cualquier pantalla del panel mientras el bypass esté activo. -->
<app-bypass-active-banner />
<router-outlet />
<!-- Montado en el root para que los toasts floten sobre el login y el shell por igual. -->
<app-toast-container />
